import React, { useContext, useState } from "react";
import { classNames } from "src/helpers/classNames";
import DocumentPreviewModal from "./DocumentPreviewModal";
import { SiteContext } from "src/context/site";
import DocumentCustomCssPreview from "./EmbedItems/DocumentCustomCssPreview";
import DocumentDefaultView from "./EmbedItems/DocumentDefaultView";

export default function DocumentEmbedded({ name = "", documents = [], content, className }) {
  const { site } = useContext(SiteContext);

  const [selectedDocIndex, setSelectedDocIndex] = useState(-1);

  const handleOpen = (doc) => {
    setSelectedDocIndex(documents?.findIndex((document) => document?._id === doc?._id));
  };

  const handleOpenById = (id) => {
    const doc = documents.find((d) => d._id === id);
    if (doc) handleOpen(doc);
  };

  return (
    <div className={classNames("relative flex h-full w-full", className)}>
      {content?.custom_html ? (
        <DocumentCustomCssPreview
          template={content?.custom_html}
          pageName={name || "Documents"}
          documents={documents}
          onDocClick={handleOpenById}
        />
      ) : site?.custom_template_enabled ? (
        <DocumentCustomCssPreview
          template={site?.custom_template_html}
          pageName={name || "Documents"}
          documents={documents}
          onDocClick={handleOpenById}
        />
      ) : (
        <DocumentDefaultView
          pageName={name || "Documents"}
          documents={documents}
          onDocumentClick={handleOpen}
        />
      )}
      <DocumentPreviewModal
        docs={documents}
        initialIndex={selectedDocIndex}
        isOpen={selectedDocIndex !== -1 ? true : false}
        onClose={() => setSelectedDocIndex(-1)}
      />
    </div>
  );
}
